import { HiChevronRight } from '@react-icons/all-files/hi/HiChevronRight';
import classNames from 'classnames';

import Link from '~/shared/components/link';

import './cta-button.scss';

type CTAButtonPropsType = {};

const CTAButton = ({
  whiteMode = false,
  htmlType = 'submit',
  content = null,
  link,
  onClick = () => {},
}: CTAButtonPropsType) => {
  const box = (
    <>
      {' '}
      {content}
      <span className="cta-button__divider" />
      <span className="cta-button__circle">
        <HiChevronRight className="cta-button__circle-chevron" />
      </span>
    </>
  );
  return link ? (
    <Link
      className={classNames('cta-button', {
        'cta-button--with-white-mode': whiteMode,
      })}
      itemProp="url"
      href={link}
    >
      {box}
    </Link>
  ) : (
    <button
      onClick={onClick}
      data-html-type={htmlType}
      className={classNames('cta-button', {
        'cta-button--with-white-mode': whiteMode,
      })}
    >
      {box}
    </button>
  );
};

export default CTAButton;
